import { action, Action } from 'easy-peasy';

export interface DragInfo {
    x?: number;
    y?: number;
    url?: string;
    // 是否存在目标图层
    isTarget?: boolean;
    opacity?: number;
    targetId?: string;
    // 是否可以释放
    isRelease?: boolean;
    // 是否到达目标
    isDrop?: boolean;
    // 是否进入layers
    isEnterLayers?: boolean;
}

export interface IMineCollapse {
    /** 弹窗显隐标识  */
    dragInfo: DragInfo;
    currentMineTab: IMineType;

    setCurrentMineTab: Action<IMineCollapse, any>;
    /** 设置显隐标识  */
    setDragInfo: Action<IMineCollapse, DragInfo>;
}

export enum IMineType {
    RECORD = 'record',
    SPACE = 'space',
}

export const mineCollapseModel: IMineCollapse = {
    dragInfo: {},
    currentMineTab: IMineType.SPACE,

    setCurrentMineTab: action((state, payload) => {
        state.currentMineTab = payload;
    }),
    setDragInfo: action((state, payload) => {
        state.dragInfo = payload;
    }),
};
